var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcnPassword = function SvgIcnPassword(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "key",
    width: 14.396,
    height: 14.396,
    viewBox: "0 0 14.396 14.396",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M14.4.421A.422.422,0,0,0,13.974,0H11.588a.422.422,0,0,0-.3.124L6.066,5.347A4.64,4.64,0,1,0,9.049,8.33l.361-.361L10.776,7.7a.422.422,0,0,0,.331-.331l.243-1.216,1.216-.243a.422.422,0,0,0,.331-.331l.231-1.16h.847a.422.422,0,0,0,.422-.422V.422Zm-.844,3.151h-.771a.422.422,0,0,0-.414.34l-.243,1.223-1.215.243a.422.422,0,0,0-.331.331l-.243,1.216-1.216.243a.422.422,0,0,0-.216.115l-.64.64a.422.422,0,0,0-.095.452A3.8,3.8,0,1,1,6.022,6.227a.422.422,0,0,0,.452-.095L11.763.844h1.193L7.71,6.089a.422.422,0,1,0,.6.6L13.552,1.44Z",
    transform: "translate(0)",
    fill: "#666"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(2.18 9.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M79.689,344.87a1.265,1.265,0,1,0,0,1.79A1.267,1.267,0,0,0,79.689,344.87Zm-.6,1.193a.422.422,0,1,1,0-.6A.422.422,0,0,1,79.092,346.063Z",
    transform: "translate(-77.529 -344.5)",
    fill: "#666"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnPassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_password.f61fb184.svg";
export { ForwardRef as ReactComponent };